import VideoPlayer from "../components/VideoPlayer";

export default function Movie() {
  return (
    <VideoPlayer url='https://nataliabarrera.com/media/videos/Peli_Bathos.mp4' muted={false} />
  );
}